<style lang="scss" scoped>
.item {
  padding-top: 10px;
  .info {
    background-color: #fff;
    padding: 15px;
    border-color: #d7dde4;
    border-collapse: separate;
    border-style: solid;
    border-width: 1px 1px 0 1px;
    .right {
      float: right;
    }
    .i {
      width: 100px;
      display: inline-block;
    }
  }
}
</style>

<template>
  <div>
    <i-table highlight-row :columns="columns" :data="source"></i-table>
  </div>
</template>

<script>
import groupBy from 'lodash.groupby';
import map from 'lodash.map';
import first from 'lodash/first';
import sum from 'lodash/sum';
import orderBy from 'lodash/orderBy';

export default {
  components: {},
  data() {
    return {
      showModal: false,
      createDate: '',
      targetNo: '',
      query: '',
      columns: [
        {
          title: '姓名',
          key: 'saleName',
        },
        {
          title: '金额',
          key: 'total',
        },
        {
          title: '操作',
          render: (h, { index }) => {
            let goDetial = () => this.go(index);

            return (
              <i-button type="primary" size="small" onClick={goDetial}>
                查看
              </i-button>
            );
          },
        },
      ],
      source: [],
      currentRow: {},
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$http
        .post('monitor/delivery', {
          name: this.query,
          ready: true,
        })
        .then(({ data }) => {
          if (data.msg === 'ok') {
            let source = map(
              groupBy(data.rows, (r) => r.sale),
              (v, k) => {
                let firstRow = first(v);
                let saleName = firstRow ? firstRow.saleName : k;
                let total = sum(
                  map(v, (r) =>
                    sum(
                      map(r.orders, (o) => {
                        o.count = -o.count;
                        return o.count * o.price;
                      })
                    )
                  )
                );
                return { sale: k, saleName, total };
              }
            );

            this.source = orderBy(source, ['total'], ['desc']);
          }
        });
    },
    pageChange() {
      this.load();
    },
    go(index) {
      let sale = this.source[index].sale;
      this.$router.push({ name: 'MonitorDelivery', query: { sale } });
    },
  },
};
</script>
